import axios from "axios";
import ElementUI from "element-ui";
import router from "@/router";
import store from "@/store";

const instance = axios.create({
  timeout: 1000 * 12,
});

instance.interceptors.request.use(
  (config) => {
    const token = store.state.token || window.localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => {
    const { data } = response;

    if (data.code === 200) {
      return Promise.resolve(data);
    }

    if (data.code === 401) {
      store.dispatch("logout");
      router.replace({
        path: "/login",
        query: {
          redirect: router.currentRoute.fullPath,
        },
      });
      return Promise.resolve(data);
    }

    if (data.code === 403) {
      ElementUI.Message.error(data.msg || "当前账号无权限访问");
      return Promise.resolve(data);
    }

    ElementUI.Message.error(data.msg || "请求失败");
    return Promise.resolve(data);
  },
  (error) => {
    const { response } = error;
    if (response && response.data && response.data.msg) {
      ElementUI.Message.error(response.data.msg);
    } else {
      ElementUI.Message.error("网络异常，请稍后重试");
    }
    return Promise.resolve(false);
  }
);

export default instance;
